import productConfig from '@config/product.config';
import i18n from '@assets/i18n/index';
import useUserInfo from '@apis/hooks/account/useUserInfo';

export const shutdown = function () {
    if (window.Intercom) {
        window.Intercom('shutdown');
    }
};

export const shutup = function () {
    const { email, name, id, signupSource } = useUserInfo();

    if (window.Intercom) {
        window.Intercom('boot', {
            app_id: 's36cqmu2',
            email,
            user_id: id,
            name,
            signup_source: signupSource
        });
    }
};

/**
 * 操作类型
 * 参考API：https://developers.intercom.com/docs/configuration
 *
 * @pararm {String} type: ['show','showMessages','showNewMessage','hide']
 */
export const operation = function (type) {
    if (window.Intercom) {
        window.Intercom(type);
    }
};

export const contact = function () {
    if (window.Intercom) {
        operation('show');
    } else if (document.querySelector('img.sc-fzXfMz')) {
        document.querySelector('img.sc-fzXfMz')?.click();
    } else {
        tiggerEmail();
    }
};

const tiggerEmail = function () {
    let a = document.querySelector('#contact_us');
    if (a) {
        a?.click?.();
    } else {
        const { email } = productConfig[i18n?.global?.locale?.toLowerCase?.() ?? 'jp'] || {};
        if (email) {
            let a = document.createElement('a');
            a.setAttribute('id', 'contact_us');
            a.setAttribute('href', `mailto: ${email}`);
            a.style.visibility = 'hidden';
            document.body.appendChild(a);
            a.click();
        }
    }
};

function update(email: string, uid?: string) {
    window?.Intercom?.('update', {
        email: email,
        user_id: uid
    });
}

export default { contact, shutdown, shutup, operation, update };
